import { motion, useReducedMotion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 140, damping: 30, mass: 0.4 });
  if (reduce) return null;
  return (
    <motion.div
      aria-hidden="true"
      data-testid="scroll-progress"
      className="fixed left-0 top-0 z-[90] h-[3px] w-full origin-left bg-gig-red"
      style={{ scaleX }}
    />
  );
}
